import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { REMOVE_GROUP_GUARDS, NEW_GROUP_ID } from '../../../../common/constants';
import type { RemoveGroupGuard, TicketType } from '../../../../common/types';
import { getTicketTypesByGroupId, getGroupIdsByTicketTypeId } from '../../selectors';
import type { ImmutableState } from '../../types';

// This action is not hooked up to any subscribers instead this data is
// expected to be retrieved on demand after a user action
// Calling this action will NOT trigger re-renders on its own
const getRemoveGroupGuard =
	(groupId: number) =>
	({ getState }: StoreActionApi<ImmutableState>): RemoveGroupGuard | undefined => {
		const state = getState();
		const ticketTypes = getTicketTypesByGroupId(state, groupId);

		if (NEW_GROUP_ID === groupId) {
			return undefined;
		}

		if (ticketTypes) {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			const orphans = ticketTypes.reduce<Array<any>>((acc, ticketType: TicketType) => {
				const groupsInTicketTypes = getGroupIdsByTicketTypeId(state, ticketType.id);
				return groupsInTicketTypes && groupsInTicketTypes.length === 1
					? // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
						[...acc, ticketType]
					: acc;
			}, []);

			if (orphans.length) {
				return {
					reason: REMOVE_GROUP_GUARDS.orphanTicketTypes,
					affectedTicketTypes: orphans,
				};
			}
		}

		return {
			reason: REMOVE_GROUP_GUARDS.userConfirmation,
		};
	};

export default getRemoveGroupGuard;
